import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link } from "react-router-dom";
import filePDF from "../assets/images/file-pdf.svg";
import * as am5 from "@amcharts/amcharts5";
import Chart from "../components/Chart";
import FundsCard from "../components/FundsCard";
import Stepform from "../components/Stepform";
import PdfDownloader from "../components/PdfDownloader";
import Skeleton from "@mui/material/Skeleton";
import ErrorComp from "../components/ErrorComp";
import VideoSlider from "../components/VideoSlider";

const ActiveInsurence = ({
  onboardingStep,
  setOnboardingStep,
  data,
  onboarding_error,
  pensionPolicies,
  balances,
  insurancePolicies,
}) => {
  const [horizontalChartsData, setHorizontalChartsData] = useState([]);
  const [horizontalChartsData2, setHorizontalChartsData2] = useState([]);
  const [pensionData, setPensionData] = useState(null);
  const [cardArrayData1, setcardArrayData1] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadinghorizontalChartsData, setLoadinghorizontalChartsData] =
    useState(true);
  const [cardDataFund, setcardDataFund] = useState([]);

  const getRandomGreenToBlueColor = (index = 1) => {
    const colors = [
      "#0072E0",
      "#158EA5",
      "#88D892",
      "#5DC8DE",
      "#AD8EE1",
      "#C58EE1",
      "#8EE1D6",
      "#A6E18E",
      "#D8E18E",
      "#DE5DDA",
    ];
    const color = colors[index];
    return am5.color(color);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const filteredDataHEALTH = insurancePolicies.filter(
          (item) => item.TAG === "HEALTH",
        );
        const filteredDataLIFE = insurancePolicies.filter(
          (item) => item.TAG === "LIFE",
        );
        const filteredDataELEM = insurancePolicies.filter(
          (item) => item.TAG === "ELEMENTARY",
        );
        const calculateMonthlyValue = (covers = []) => {
          return covers.reduce((sum, cover) => {
            const amount = parseFloat(cover?.PREMIUME_AMOUNT_IN_NIS || 0);
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              return sum + amount;
            }

            if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              return sum + amount / 12;
            }

            return sum;
          }, 0);
        };
        const transformedData = filteredDataHEALTH.map((element, index) => ({
          category: element.MAIN_BRANCH,
          value: calculateMonthlyValue(element?.Covers),
          settings: {
            fill: getRandomGreenToBlueColor(index),
          },
        }));
        const transformedDataLIFE = filteredDataLIFE.map((element, index) => ({
          category: element.MAIN_BRANCH,
          value: calculateMonthlyValue(element?.Covers),
          settings: {
            fill: getRandomGreenToBlueColor(index),
          },
        }));
        const transformedDataELEM = filteredDataELEM.map((element, index) => ({
          category: element.MAIN_BRANCH,
          value: calculateMonthlyValue(element?.Covers),
          settings: {
            fill: getRandomGreenToBlueColor(index),
          },
        }));

        // Total Data for center of chart -Start
        let monthlyYearlyDataForTotal = {
          monthlyHealth: 0,
          monthlyElem: 0,
          monthlyLife: 0,
          yearlyHealth: 0,
          yearlyElem: 0,
          yearlyLife: 0,
        };
        filteredDataHEALTH?.forEach((item) => {
          item?.Covers?.forEach((cover) => {
            const premiumAmount = parseFloat(
              cover?.PREMIUME_AMOUNT_IN_NIS || 0,
            );
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              monthlyYearlyDataForTotal.monthlyHealth += premiumAmount;
            } else if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              monthlyYearlyDataForTotal.yearlyHealth += premiumAmount;
            }
          });
        });
        filteredDataLIFE?.forEach((item) => {
          item?.Covers?.forEach((cover) => {
            const premiumAmount = parseFloat(
              cover?.PREMIUME_AMOUNT_IN_NIS || 0,
            );
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              monthlyYearlyDataForTotal.monthlyLife += premiumAmount;
            } else if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              monthlyYearlyDataForTotal.yearlyLife += premiumAmount;
            }
          });
        });
        filteredDataELEM?.forEach((item) => {
          item?.Covers?.forEach((cover) => {
            const premiumAmount = parseFloat(
              cover?.PREMIUME_AMOUNT_IN_NIS || 0,
            );
            if (
              cover?.PREMIUME_TYPE === "2" ||
              cover?.PREMIUME_TYPE === "חודשית"
            ) {
              monthlyYearlyDataForTotal.monthlyElem += premiumAmount;
            } else if (
              cover?.PREMIUME_TYPE === "1" ||
              cover?.PREMIUME_TYPE === "שנתית"
            ) {
              monthlyYearlyDataForTotal.yearlyElem += premiumAmount;
            }
          });
        });
        const paymentData = [
          {
            amounts: {
              monthly:
                monthlyYearlyDataForTotal?.monthlyHealth +
                monthlyYearlyDataForTotal?.yearlyHealth / 12,
              // yearly: monthlyYearlyDataForTotal?.yearlyHealth + monthlyYearlyDataForTotal?.monthlyHealth * 12,
            },
          },
          {
            amounts: {
              monthly:
                monthlyYearlyDataForTotal?.monthlyLife +
                monthlyYearlyDataForTotal?.yearlyLife / 12,
              // yearly: monthlyYearlyDataForTotal?.yearlyLife + monthlyYearlyDataForTotal?.monthlyLife * 12,
            },
          },
          {
            amounts: {
              monthly:
                monthlyYearlyDataForTotal?.monthlyElem +
                monthlyYearlyDataForTotal?.yearlyElem / 12,
              // yearly: monthlyYearlyDataForTotal?.yearlyElem + monthlyYearlyDataForTotal?.monthlyElem * 12,
            },
          },
        ];
        // Total Data for center of chart - End

        let arrayDataForChart = [
          {
            id: `chart1-${insurancePolicies.length}`,
            title: "אלמנטרי",
            total: paymentData ? paymentData[2]?.amounts?.monthly : 0,
            totalLabel: "סך הכל מזומן",
            data: aggregateData(transformedDataELEM),
          },
          {
            id: `chart2-${insurancePolicies.length}`,
            title: "בריאות",
            total: paymentData ? paymentData[0]?.amounts?.monthly : 0,
            totalLabel: "סך הכל מזומן",
            data: aggregateData(transformedData),
          },
          {
            id: `chart3-${insurancePolicies.length}`,
            title: "חיים",
            total: paymentData ? paymentData[1]?.amounts?.monthly : 0,
            totalLabel: "סך הכל מזומן",
            data: aggregateData(transformedDataLIFE),
          },
        ];
        setHorizontalChartsData2(arrayDataForChart);
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const fetchData1 = async () => {
      try {
        const processedDataSummary = [
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Total),
                    0,
                  ) || 0
                : 0,
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Pensya),
                    0,
                  ) || 0
                : 0,
          },
          {
            field:
              onboardingStep === 5 || (balances && balances.length)
                ? balances[0]?.Yetrot?.reduce(
                    (sum, item) => sum + parseFloat(item.Hishtalmut),
                    0,
                  ) || 0
                : 0,
          },
        ];
        return processedDataSummary;
      } catch (error) {
        console.error("Error fetching balance data:", error);
      }
    };
    const fetchData = async () => {
      setLoadinghorizontalChartsData(true);
      try {
        const balanceCallBack = await fetchData1();
        let allLoans = (pensionPolicies || [])
          .filter((item) => item?.duplicate !== true)
          .flatMap((item) => {
            let halvas = Array.isArray(item?.Halvaa)
              ? item?.Halvaa
              : [item?.Halvaa];
            return halvas?.filter(Boolean).map((h) => ({
              ...item,
              Halvaa: h,
            }));
          });

        const uniqueLoansMap = new Map();
        allLoans.forEach((loan) => {
          const key = loan?.Halvaa?.MISDAR_SIDURI_SHEL_HAHALVAA;
          if (key && !uniqueLoansMap.has(key)) {
            uniqueLoansMap.set(key, loan);
          }
        });
        const uniqueLoans = Array.from(uniqueLoansMap.values());
        setPensionData(
          (pensionPolicies || []).filter((item) => item?.duplicate !== true),
        );

        const transformedData = [
          {
            category: "סך יתרת ההלוואה",
            value: uniqueLoans.reduce((sum, item) => {
              const halvaa = Array.isArray(item.Halvaa)
                ? item.Halvaa[0]
                : item.Halvaa;
              return sum + parseFloat(halvaa?.YITRAT_HALVAA || 0);
            }, 0),
            settings: {
              fill: getRandomGreenToBlueColor(0),
            },
          },
          {
            category: "סך הלוואות ששולמו",
            value: Math.max(
              uniqueLoans.reduce((sum, item) => {
                const halvaa = Array.isArray(item.Halvaa)
                  ? item.Halvaa[0]
                  : item.Halvaa;
                return sum + parseFloat(halvaa?.SCHUM_HALVAA || 0);
              }, 0) -
                uniqueLoans.reduce((sum, item) => {
                  const halvaa = Array.isArray(item.Halvaa)
                    ? item.Halvaa[0]
                    : item.Halvaa;
                  return sum + parseFloat(halvaa?.YITRAT_HALVAA || 0);
                }, 0),
              0,
            ),
            settings: {
              fill: getRandomGreenToBlueColor(1),
            },
          },
        ];
        const cardDataFundTemp = [
          { title: "קצבה צפויה", RIBIT: 0 },
          { title: "הסכום הצפוי בגיל פרישה", SCHUM_HECHZER_TKUFATI: 0 },
        ];
        (pensionPolicies || [])
          .filter((item) => item?.duplicate !== true)
          .forEach((item) => {
            const YitraLefiGilPrisha = Array.isArray(item?.YitraLefiGilPrisha)
              ? item?.YitraLefiGilPrisha[0]
              : item?.YitraLefiGilPrisha;

            const kupot = YitraLefiGilPrisha?.kupot;

            if (kupot) {
              kupot.forEach((kupa) => {
                if (kupa.KITZVAT_HODSHIT_TZFUYA) {
                  cardDataFundTemp[0].RIBIT +=
                    parseFloat(kupa.KITZVAT_HODSHIT_TZFUYA || 0) || 0;
                }
              });
            }
            if (YitraLefiGilPrisha?.TZVIRAT_CHISACHON_CHAZUYA_LELO_PREMIYOT) {
              cardDataFundTemp[1].SCHUM_HECHZER_TKUFATI +=
                parseFloat(
                  YitraLefiGilPrisha?.TOTAL_CHISACHON_MITZTABER_TZAFUY || 0,
                ) || 0;
            }
          });
        setcardDataFund(cardDataFundTemp);

        const transformedData2 = [
          {
            category: "קרן השתלמות",
            value: balanceCallBack[2]?.field,
            settings: {
              fill: getRandomGreenToBlueColor(0),
            },
          },
          {
            category: "קרן פנסיה",
            value: balanceCallBack[1]?.field,
            settings: {
              fill: getRandomGreenToBlueColor(1),
            },
          },
        ];
        const cardArrayData = [
          {
            title: "ממוצע % ריבית",
            RIBIT: (() => {
              if (
                !pensionPolicies?.filter((item) => item?.duplicate !== true)
                  ?.length
              )
                return 0;

              let total = 0;
              let count = 0;

              for (const item of uniqueLoans) {
                const halvaa = Array.isArray(item.Halvaa)
                  ? item.Halvaa[0]
                  : item.Halvaa;
                const ribit = parseFloat(halvaa?.RIBIT || 0);

                if (ribit > 0) {
                  total += ribit;
                  count++;
                }
              }

              return count ? total / count : 0;
            })(),
          },
          {
            title: "סה”כ החזרים תקופתיים",
            SCHUM_HECHZER_TKUFATI: uniqueLoans.reduce((sum, item) => {
              if (Array.isArray(item.Halvaa)) {
                return (
                  sum +
                  item.Halvaa.reduce(
                    (innerSum, h) =>
                      innerSum + parseFloat(h?.SCHUM_HECHZER_TKUFATI || 0),
                    0,
                  )
                );
              } else {
                return (
                  sum + parseFloat(item.Halvaa?.SCHUM_HECHZER_TKUFATI || 0)
                );
              }
            }, 0),
          },
        ];
        setcardArrayData1(cardArrayData);

        let arrayDataForChart = [
          {
            id: `filteredLIFEArrayData1-${pensionPolicies.length}`,
            title: "LIFE",
            total: balanceCallBack[0]?.field,
            totalLabel: "סה״כ חסכון נוכחי",
            data: transformedData2,
          },
          {
            id: `filteredHEALTHArray-${pensionPolicies.length}`,
            title: "Not fixed",
            total: uniqueLoans.reduce((sum, item) => {
              const halvaa = Array.isArray(item.Halvaa)
                ? item.Halvaa[0]
                : item.Halvaa;
              return sum + parseFloat(halvaa?.SCHUM_HALVAA || 0);
            }, 0),
            totalLabel: "סך הכל",
            data: transformedData,
          },
        ];
        setHorizontalChartsData(arrayDataForChart);
      } catch (err) {
        console.log(err);
      } finally {
        setLoadinghorizontalChartsData(false);
      }
    };
    fetchData();
  }, []);
  const aggregateData = (transformedData) => {
    return transformedData.reduce((acc, item) => {
      const existingCategory = acc.find(
        (obj) => obj.category === item.category,
      );

      if (existingCategory) {
        existingCategory.value += item.value;
      } else {
        acc.push({
          category: item.category,
          value: item.value,
          settings: { fill: item.settings.fill },
        });
      }

      return acc;
    }, []);
  };

  const [UserData, setUserData] = useState({});
  const getUser = async () => {
    setUserData(data);
  };

  useEffect(() => {
    if (
      window.location.pathname !== "/login" &&
      window.location.pathname !== "/register"
    ) {
      getUser();
    }
  }, []);
  return (
    <>
      <div className="video-slider-section">
        <VideoSlider />
      </div>
      <div className="heading-wrap d-flex justify-content-between">
        <div className="heading">
          <div className="head-wrap">
            <Breadcrumbs className="breadcrumbs" aria-label="breadcrumb">
              <Link to="/profile" underline="hover">
                {UserData?.full_name}
              </Link>
              <Typography>
                <b>מבט מהיר</b>
              </Typography>
            </Breadcrumbs>
            <h1>ברוכים השבים, {UserData?.full_name}</h1>
          </div>
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="summery_page.pdf">
              <img src={filePDF} alt="" />
            </PdfDownloader>
          </div>
          <p>
            !ברוכים הבאים ללוח הבקרה של אובקטיבי <br />
            זהו המרכז שלכם לניהול ושיפור המצב הפיננסי, הפנסיוני והביטוחי שלכם.
            כאן תוכלו למצוא סקירה מקיפה של כל המוצרים והפוליסות שלכם, ביטוחים,
            פנסיה, חסכונות, קרנות, הלוואות, נתוני פרישה, אפשרויות משיכה ועוד..
            הכל כאן! <br />
            כל אחד מלוחות הבקרה נועד לספק לכם תובנות ברורות והמלצות לפעולה.
            הציצו בעמודים הפנימיים כדי להעמיק בנתונים שלכם, לעקוב אחר ההתקדמות
            ולגלות הזדמנויות לשיפור עתידכם הפיננסי - הכול בפלטפורמה אובייקטיבית
            אחת.
          </p>
        </div>
        <div className="btns-row">
          <div className="btn btn-img pdf_btn">
            <PdfDownloader fileName="summery_page.pdf">
              <img src={filePDF} alt="" /> הפקת דוח
            </PdfDownloader>
          </div>
          <br />
        </div>
      </div>
      {onboarding_error == 1 && <ErrorComp />}

      <Stepform
        fromPage="Loading"
        setOnboardingStep={setOnboardingStep}
        onboardingStep={onboardingStep}
        data={data}
      />
      <FundsCard
        pensionData={pensionData}
        from="summaryPage"
        onboardingStep={onboardingStep}
        balances={balances}
      />

      <div className="insurances-section">
        <div className="title">
          <h2>ביטוחים</h2>
        </div>
        <div className="row chart-row">
          {console.log(
            "horizontalChartsData2.length",
            horizontalChartsData2.length,
          )}
          {horizontalChartsData2.length === 0 || loading
            ? [...Array(3)].map((_, index) => (
                <div className="col-4" key={`skeleton-${index}`}>
                  <Skeleton
                    variant="rectangular"
                    width="100%"
                    height={300}
                    animation="wave"
                    sx={{
                      backgroundColor: "rgba(0, 0, 0, 0.05)",
                      borderRadius: 1,
                    }}
                  />
                </div>
              ))
            : horizontalChartsData2.map((chart, index) => (
                <div className="col-4" key={`insurances-${index}`}>
                  {console.log("chart.total", chart.total)}
                  <Chart
                    id={`hor${index}`}
                    data={chart.data}
                    total={chart.total}
                    title={chart.title}
                    totalLabel={chart.totalLabel}
                    variant="insurances"
                    spaces="noSpaces"
                  />
                </div>
              ))}
        </div>
      </div>

      <div className="calculation-section">
        <div className="row chart-row">
          {horizontalChartsData.length === 0 || loadinghorizontalChartsData
            ? [...Array(2)].map((_, index) => (
                <div className="col-6" key={`calculation-${index}`}>
                  <div className="title">
                    <h2>{index === 0 ? "פרישה" : "הלוואות"}</h2>
                  </div>
                  <div className="col" key={`skeleton-${index}`}>
                    <Skeleton
                      variant="rectangular"
                      width="100%"
                      height={600}
                      animation="wave"
                      sx={{
                        backgroundColor: "rgba(0, 0, 0, 0.05)",
                        borderRadius: 1,
                      }}
                    />
                  </div>
                </div>
              ))
            : horizontalChartsData.map((chart, index) => (
                <div className="col-6" key={`calculation-${index}`}>
                  <div className="title">
                    <h2>{index === 0 ? "פרישה" : "הלוואות"}</h2>
                  </div>
                  <Chart
                    id={`cal${index}`}
                    data={chart.data}
                    total={chart.total}
                    title={chart.title}
                    totalLabel={chart.totalLabel}
                    variant="calculation"
                    from="summary"
                    count="2"
                    cardArrayData={index === 1 ? cardArrayData1 : cardDataFund}
                    indexKey={index}
                  />
                </div>
              ))}
        </div>
      </div>

      {/* <div className="loans-section">
        <div className="title">
          <h2>הלוואות</h2>
        </div>
        <div className="loans-cards d-flex flex-wrap gap-16">
          <div className="cards-box white-bg radius-16">
            <h6>סה״כ כסף פנוי - נזיל</h6>
            <Skeleton
              variant="rectangular"
              width="50%"
              height={25}
              animation="wave"
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                borderRadius: 1,
              }}
            />
          </div>
          <div className="cards-box white-bg radius-16">
            <h6>סה״כ שאפשר לקבל בהלוואה</h6>
            <Skeleton
              variant="rectangular"
              width="50%"
              height={25}
              animation="wave"
              sx={{
                backgroundColor: "rgba(0, 0, 0, 0.05)",
                borderRadius: 1,
              }}
            />
          </div>
        </div>
      </div> */}
    </>
  );
};

export default ActiveInsurence;
